import $ from "jquery";
import "slick-carousel";

// Declare jQuery globally if needed
declare global {
  interface Window {
    $: typeof $;
    jQuery: typeof $;
  }
}

// Ensure jQuery is globally available
if (typeof window !== "undefined") {
  window.$ = window.jQuery = $;
}

export default defineNuxtPlugin((nuxtApp) => {});
